module.exports = __webpack_public_path__ + "media/shared/desnivel-izquierdo-icon-27bb9101.png";